import type { Notificacion } from "@/types/models/notificaciones";
import { notificacionesRepository } from "../repositories/notificaciones.repository";

export const notificacionesService = {
  async fetchByUser(userId: string): Promise<Notificacion[]> {
    return notificacionesRepository.fetchByUser(userId);
  },

  async waitForAuth(): Promise<void> {
    await notificacionesRepository.waitForToken();
  },

  async markAsRead(id: string): Promise<void> {
    await notificacionesRepository.markAsRead(id);
  },

  async markAsActive(id: string): Promise<void> {
    await notificacionesRepository.markAsActive(id);
  },

  async delete(id: string): Promise<void> {
    await notificacionesRepository.delete(id);
  },

  async deleteAll(notificaciones: Notificacion[]): Promise<void> {
    const ids = notificaciones.map((n) => n.id);
    if (!ids.length) return;

    await notificacionesRepository.deleteMany(ids);
  },
};